import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthModalComponent } from "./components/auth-modal/auth-modal.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LostPasswordComponent } from "./pages/lost-password/lost-password.component";
import { SharedModule } from "../shared/shared.module";
import { SweetAlert2Module } from "node_modules/sweetalert2/src/sweetalert2";
import { CadastroInvestidorComponent } from "./pages/cadastro-investidor/cadastro-investidor.component";
import { FormularioEntidadeComponent } from "./components/forms/formulario-entidade/formulario-entidade.component";
import { AuthIntervenienteComponent } from "./pages/auth-interveniente/auth-interveniente.component";
import { ModalResetPasswordTokenComponent } from "./components/modal-reset-password-token/modal-reset-password-token.component";
import { AuthInvestidorComponent } from './pages/auth-investidor/auth-investidor.component';
import { InfoPerfisComponent } from './components/info-perfis/info-perfis.component';
import { SelecaoTipoUsuarioComponent } from "./components/selecao-tipo-usuario/selecao-tipo-usuario.component";
import { CadastroUsuarioComponent } from "./components/forms/cadastro-usuario/cadastro-usuario.component";
import { EtapaCadastroEmailComponent } from "./components/forms/etapa-cadastro-email/etapa-cadastro-email.component";
import { DadosCredorComponent } from "./components/forms/dados-credor/dados-credor.component";
import { ComplementoCadastroComponent } from "./components/complemento-cadastro/complemento-cadastro.component";

@NgModule({
  declarations: [
    AuthModalComponent,
    LostPasswordComponent,
    CadastroInvestidorComponent,
    SelecaoTipoUsuarioComponent,
    CadastroUsuarioComponent,
    EtapaCadastroEmailComponent,
    DadosCredorComponent,
    FormularioEntidadeComponent,
    AuthIntervenienteComponent,
    ModalResetPasswordTokenComponent,
    AuthInvestidorComponent,
    InfoPerfisComponent,
    ComplementoCadastroComponent
  ],
  imports: [FormsModule, SharedModule, CommonModule, ReactiveFormsModule],
  entryComponents: [AuthModalComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AuthModule {}
